"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOrderProducts = useOrderProducts;
var _reactRedux = require("react-redux");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _productPositionSelectors = require("../../../redux/selectors/productPositionSelectors");
var _reselect = require("reselect");
var orderProductsSelector = (0, _reselect.createSelector)(_instrumentPositionSelectors.selectedInstrumentSelector, _productPositionSelectors.productPositionSelector, function (instrument, balances) {
  return {
    instrumentId: instrument.InstrumentId,
    instrumentSymbol: instrument.VenueSymbol,
    product1: balances.find(function (b) {
      return b.Product === instrument.Product1Symbol;
    }),
    product2: balances.find(function (b) {
      return b.Product === instrument.Product2Symbol;
    })
  };
});
function useOrderProducts() {
  return (0, _reactRedux.useSelector)(orderProductsSelector);
}